import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import AnimateHeight from 'react-animate-height'
import RoundedIcon from '~components/ui/RoundedIcon'
import Parse from 'html-react-parser'

const AccordionItem = (props) => {
  return (
    <section aria-expanded={props.active} className={classNames('border-coral border-t', props.classNames)}>
      <h3 className="w-full">
        <button type="button" className={classNames('w-full text-left text-base xs:text-sm flex items-center justify-between py-6 lg:py-8 xl:py-10')} onClick={props.onClick}>
          {props.title}

          <RoundedIcon
            name={props.active ? 'minus' : 'plus'}
            className="w-6 h-6 ml-5 pointer-events-none flex-shrink-0 flex-grow-0"
          />
        </button>
      </h3>

      {props.content && (
        <AnimateHeight duration={300} height={props.active ? 'auto' : 0}>
          <div className="editor editor-standard w-full pb-6 lg:pb-8 xl:pb-10">
            {Parse(props.content)}
          </div>
        </AnimateHeight>
      )}
    </section>
  )
}

AccordionItem.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  classNames: PropTypes.string
}

export default AccordionItem
